/**
 * @feature user
 * @description Contains the reducer and dispatch actions for user profiles as well as the custom useProfile hooks and types.
 */

export { default as userInitialState } from './initialState';
export { default as userReducer } from './reducer';
export { default as useProfile } from './useProfile';
export * from './actions';
export * from './types';